import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { LiabilitiesDelagateConfirmationModel } from 'src/app/shared/models/liabilities-delagate-confirmation.model';

@Component({
standalone: false,
  selector: 'app-biller-sub-account-delegate-confirmation-dialog',
  templateUrl: './biller-sub-account-delegate-confirmation-dialog.component.html',
  styleUrls: ['./biller-sub-account-delegate-confirmation-dialog.component.scss'],
})
export class BillerSubAccountDelegateConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: LiabilitiesDelagateConfirmationModel) {}
}
